import * as types from '../actions/types'
import Immutable from 'immutable'
import moment from 'moment'

import {
    isPrimitive,
    solicitudservicioitem,
    solicitudservicioitemcenco,
    solicitudserviciofile,
    guid,
    foro
} from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
    solicitante: null,
    fecha_requerido: null,
    ordenador_gasto: null,
    proveedor: null,
    responsable_recibo: [],
    responsable_ingreso: [],
    proyecto_evento: '',
    observaciones: '',
    servicios: [],
    cencos: [],
    anticipo: 0,
    adjuntos: [],
    modalAddServicio: {
        show: false,
        title: '',
        mode: null,
        data: null,
        btnDisabled: false
    },
    modalAddFile: {
        show: false,
        title: '',
        data: null,
        btnDisabled: false
    },
    btnSaveDisabled: false,
    tipo: 3,
    moneda: 'COP',
    foros:[],
    comentario: {
        guid: null, 
        texto: null
    }

})

export default function (state = INITIAL_STATE, action) {
    let data, index
	switch (action.type) {
        case types.REINICIAR_SOLICITUD_SERVICIO_OT:
            return INITIAL_STATE
        case types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state
        case types.MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT:
            state = state.setIn(['modalAddServicio', 'title'], action.payload.title)
            state = state.setIn(['modalAddServicio', 'show'], action.payload.show)
            state = state.setIn(['modalAddServicio', 'mode'], action.payload.mode)
            data = Immutable.fromJS(solicitudservicioitem())
			if (action.payload.mode === 'edit') {
                data = state.getIn(['servicios', String(action.payload.index)])
			}
            state = state.setIn(['modalAddServicio', 'data'], data)
            return state
        case types.OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT:
            state = state.set('modalAddServicio', INITIAL_STATE.get('modalAddServicio'))
            return state
		case types.ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT:
            let actual = state.get('cencos').reduce((a ,b) => { a += Number(b.get('porcentaje')); return a }, 0)
			state = state.update('cencos', list => list.push(Immutable.fromJS(solicitudservicioitemcenco(actual))))
			return state
        case types.ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM:
			state = state.update('cencos', list => list.filter(x => !x.get('selected')))
			return state
        case types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT:
            data = state.getIn(['modalAddServicio', 'data'])
            index = state.get('servicios').findIndex(x => x.get('guid') === data.get('guid'))
            if (index === -1) {
                state = state.set('servicios', state.get('servicios').push(data))
            } else {
                state = state.setIn(['servicios', String(index)], data)
            }
			return state
        case types.MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT:
            state = state.setIn(['modalAddFile', 'title'], action.payload.title)
            state = state.setIn(['modalAddFile', 'show'], action.payload.show)
            data = Immutable.fromJS(solicitudserviciofile())
			if (action.payload.mode === 'edit') {
                data = state.getIn(['adjuntos', String(action.payload.index)])
			}
            state = state.setIn(['modalAddFile', 'data'], data)
            return state
        case types.OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT:
            state = state.set('modalAddFile', INITIAL_STATE.get('modalAddFile'))
            return state
        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT:
            data = action.payload
            index = state.get('adjuntos').findIndex(x => x.get('guid') === data.get('guid'))
            data = data.set('nombre', `${data.get('nombre')}`)
            if (index === -1) {
                state = state.set('adjuntos', state.get('adjuntos').push(data))
            } else {
                data = data.set('updated', true)
                state = state.setIn(['adjuntos', String(index)], data)
            }
			return state
        case types.ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT:
            state = state.update('adjuntos', list => list.filter(x => !x.get('selected')))
            return state
        case types.RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT:
            state = state.set('adjuntos', Immutable.fromJS(action.payload))
            return state
        case types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT:
            state = state.setIn(action.payload.path.split('.'),  Immutable.fromJS(action.payload.value))
            return state
		case types.ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT:
            data = { guid: guid(), selected: false }
			state = state.update(action.payload, list => list.push(Immutable.fromJS(data)))
			return state
        case types.ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT:
			state = state.update(action.payload.path, list => list.filter(x => !x.get('selected')))
            return state
        case types.ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT:
            state = state.update('servicios', list => list.filter(x => !x.get('selected')))
            return state

        case types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT:
            state = state.set('btnSaveDisabled', action.payload)
            return state



        case types.ENVIAR_COMENTARIO_SOLICITUD_OT:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            if(index === -1){          
                const data = Immutable.fromJS(foro(action.payload.usuario, action.payload.comentario))
                state = state.set('foros', state.get('foros').push(data))
            }else{
                state = state.setIn(['foros', index, 'comentario'], action.payload.comentario)
            }
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

        case types.EDITAR_COMENTARIO_SOLICITUD_OT:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.setIn(['comentario','guid'], action.payload.guid)
            state = state.setIn(['comentario','texto'], state.getIn(['foros', index, 'comentario']))
            return state

        case types.ELIMINAR_COMENTARIO_SOLICITUD_OT:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.deleteIn(['foros', index])
            return state

            
        default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/creacionsolicitudservicioot.js